module.exports = __webpack_public_path__ + "media/images/emblems/Tartegnin-coat_of_arms-7220a349f145a99c49ba3bb11da5f329.svg";